import type { ContextMenuState, ReduxAction } from '@repo/utils/types';

const initialContextMenuState = {
  isOpen: false,
  coords: { x: 0, y: 0 },
  viewportDimensions: { width: 0, height: 0 },
};

export function contextMenuReducer(
  state: ContextMenuState = initialContextMenuState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'OPEN_CONTEXT_MENU':
      return {
        ...state,
        ...payload,
        isOpen: true,
      };

    case 'CLOSE_CONTEXT_MENU':
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
}
